import {remCalc} from '_themeUtils'

const control_checked_default = {
    bg: 'color.background.transparent',
    borderColor: 'color.border.input.primary',
    color: 'color.text.input.base',
    _hover: {
        borderColor: 'color.border.input.primary',
        bg: 'color.background.transparent',
    },
    _focus: {
        borderColor: 'color.border.input.primary',
    },
    _disabled: {
        bg: 'color.background.grey[400]',
        borderColor: 'color.border.input.disabled',
        outlineWidth: remCalc(1.5),
        outlineOffset: remCalc(-2),
        outlineColor: 'color.border.white',

        _hover: {
            bg: 'color.background.grey[400]',
            borderColor: 'color.border.input.disabled',
        },
    },
}

const radio = {
    Radio: {
        baseStyle: {
            container: {
                w: 'fit-content',
                textStyle: 'paragraphSm',
                letterSpacing: remCalc(1),
            },
            label: {
                fontSize: 'inherit',
                color: 'color.text.input.base',
                fontWeight: '400',
                mb: 'spacing.6',
                _invalid: {
                    color: 'color.text.input.error',
                },
            },
            control: {
                position: 'relative',
                w: remCalc(20),
                h: remCalc(20),
                border: 1,
                borderStyle: 'solid',
                borderColor: 'color.border.input.primary',
                outline: `${remCalc(1)} solid`,
                outlineColor: 'color.border.transparent',
                outlineOffset: 0,
                transition: 'all .2s ease-in-out',
                mb: 'spacing.6',
                _before: {
                    content: '""',
                    width: remCalc(0),
                    height: remCalc(0),
                    position: 'absolute !important',
                    top: '50%',
                    left: '50%',
                    bg: 'color.background.black',
                    borderRadius: 'full',
                    lineHeight: 0,
                    transform: 'translate(-50%, -50%)',
                    transition: 'all .2s ease-in-out',
                },

                _disabled: {
                    bg: 'color.background.input.primary',
                    borderColor: 'color.border.input.disabled',
                    outlineWidth: remCalc(1.5),
                    outlineOffset: remCalc(-2),
                    outlineColor: 'border.border-white',

                    _hover: {
                        bg: 'color.background.input.primary',
                        borderColor: 'color.border.input.disabled',
                    },
                },
                _checked: {
                    ...control_checked_default,
                    _before: {
                        width: remCalc(11),
                        height: remCalc(11),
                    },
                },
            },
        },
        sizes: {
            sm: {
                control: {
                    w: remCalc(16),
                    h: remCalc(16),
                },
            },
            md: {
                control: {
                    w: remCalc(20),
                    h: remCalc(20),
                },
            },
            lg: {
                control: {
                    w: remCalc(20),
                    h: remCalc(20),
                },
            },
            newsletter: {
                container: {
                    w: 'fit-content',
                    textStyle: 'paragraphSm',
                    letterSpacing: remCalc(1),
                },
                label: {
                    fontSize: remCalc(12),
                    color: 'color.text.input.base',
                    fontWeight: '300',
                    mb: 'spacing.6',
                    _invalid: {
                        color: 'color.text.input.error',
                    },
                },
                control: {
                    w: remCalc(18),
                    h: remCalc(18),
                    mb: 'spacing.6',
                    _checked: {
                        _before: {
                            width: remCalc(10),
                            height: remCalc(10),
                        },
                    },
                },
            },
        },
    },
}

export default radio
